import { useEffect } from 'react';

// Essential content is visible before enhancement; motion never gates reading.
export default function useSectionMotion(rootRef) {
  useEffect(() => {
    const root = rootRef.current;
    if (!root || !window.IntersectionObserver || !Element.prototype.animate) return undefined;
    const preference = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const animations = new Set();
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (preference?.matches || document.hidden) return;
        const animation = entry.target.animate([
          { opacity: .68, transform: 'translateY(18px)' },
          { opacity: 1, transform: 'translateY(0)' },
        ], { duration: 520, easing: 'cubic-bezier(.23,1,.32,1)' });
        animations.add(animation);
        animation.onfinish = () => animations.delete(animation);
      });
    }, { threshold: .07 });
    root.querySelectorAll('main > section:not(.qcl-hero), main > div').forEach(el => observer.observe(el));
    const settle = () => { if (document.hidden || preference?.matches) animations.forEach(animation => animation.finish()); };
    document.addEventListener('visibilitychange', settle);
    preference?.addEventListener?.('change', settle);
    return () => {
      observer.disconnect(); animations.forEach(animation => animation.cancel());
      document.removeEventListener('visibilitychange', settle);
      preference?.removeEventListener?.('change', settle);
    };
  }, [rootRef]);
}
